import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProgressSpinner],
})
export class SpinnerComponent {}
